import { ImageIcon } from '@saleshandy/design-system';
import React, { memo, useEffect, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { Images } from '../../../../../../../shared/app-constants';
import { accessibleOnClick } from '../../../../../../../shared/utils/accessible-on-click';
import { executeOnRequestStatus } from '../../../../../../../shared/utils';
import { RequestStatus } from '../../../../../../../shared/enums/request-status';

/**
 * @description
 * A UI component that displays an error message when the AI response fails.
 * It includes an icon, a brief message, and a refresh button prompting the user to retry the operation.
 *
 * @returns React Componnet
 */

const AiErrorRespond = ({
  saveCurrentStepDetails,
  currentStepPayload,
  saveAiSeqGeneratorStepDetailsRequestStatus,
}: {
  saveCurrentStepDetails: (payload: any) => void;
  currentStepPayload: any;
  saveAiSeqGeneratorStepDetailsRequestStatus: RequestStatus;
}) => {
  const [isLoadingActive, setIsLoadingActive] = useState<boolean>(false);

  const handleButtonClick = () => {
    setIsLoadingActive(true);
    saveCurrentStepDetails(currentStepPayload);
  };

  useEffect(() => {
    executeOnRequestStatus({
      status: saveAiSeqGeneratorStepDetailsRequestStatus,
      onSuccess: () => {
        setIsLoadingActive(false);
      },
      onFailed: () => {
        setIsLoadingActive(false);
      },
    });
  }, []);

  return (
    <div className="ai-error-response-container">
      <div className="ai-error-response-header">
        <ImageIcon src={Images.InfoCircleYellow} alt="info-circle-yellow" />
        <span>Something went wrong </span>
      </div>
      <span>It seems there was an issue on our end.</span>
      <span>Would you like to try again?</span>
      <div className="ai-error-response-btn">
        <Button
          className="ai-error-response-refresh-btn"
          {...accessibleOnClick(handleButtonClick)}
          disabled={isLoadingActive}
        >
          {isLoadingActive ? (
            <Spinner animation="border" className="spinner-icon" />
          ) : (
            <>
              <ImageIcon src={Images.RefreshWhite} alt="refresh-white" />
              Retry
            </>
          )}
        </Button>
      </div>
    </div>
  );
};
export default memo(AiErrorRespond);
